import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { CourseOwnershipProvider } from './contexts/CourseOwnershipContext';
import GlobalStyles from './styles/GlobalStyles';
import AppRoutes from './routes';
import Toaster from './components/common/Toaster';
import FloatingParticles from './components/common/FloatingParticles';

const AppContent = () => {
  return (
    <>
      <GlobalStyles />
      <FloatingParticles count={30} />
      <AppRoutes />
      <Toaster />
    </>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <CourseOwnershipProvider>
          <AppContent />
        </CourseOwnershipProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
